import "../button/btn.css"

import React, { forwardRef } from "react"

import { BaseLink, BaseLinkElementProps } from "./BaseLink"

export type LinkProps = Omit<BaseLinkElementProps, "label"> & {
  children?: React.ReactNode
  label?: string
}

/**
 * A link component that renders as an HTML `<a>` element with button-like
 * styling. Use for navigation; for actions that don't change the URL, use
 * `Button` instead.
 *
 * @component
 * @see {@link https://planningcenter.github.io/tapestry/?path=/docs/components-link--docs | Storybook Documentation}
 */
export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ href, ...restProps }: LinkProps, ref) => {
    return <BaseLink href={href} ref={ref} {...restProps} />
  }
)

Link.displayName = "Link"
